import StyledBanner from "./style";

const AnimatedBanner = () => {
	return (
		<StyledBanner>
			<span>FAÇA SUA DOAÇÃO</span>
			<span>FAÇA SUA DOAÇÃO</span>
			<span>FAÇA SUA DOAÇÃO</span>
		</StyledBanner>
	);
};

export default AnimatedBanner;
